import { createSelector } from 'reselect';
import { getReportState } from 'src/modules/report/selectors/getReportState';

export const getReportLoading = createSelector([
  getReportState,
], (state) => state.status?.state === 'pending');
